/**
 * Form script
 */
class CodeForm {
    constructor() {
        this.initState();
    }

    initState() {
        this.codeForm = $('.code-form');
        this.codeFormStep2 = $('.code-form-step-2');

        if (!this.codeForm.length) {
            return
        }

        this.initEvents();
    }

    initEvents() {
        let formHelper = new FormHelper(this.codeForm);
        let formHelperStep2 = new FormHelper(this.codeFormStep2);
        let id = null;
        let isCheckStatus = false;

        if (window.location.search.includes('isOpenPopUp')) {
            $('.popup-block-form').removeClass('is-hidden');
            $('body').addClass('no-scroll');

            const urlParams = new URLSearchParams(window.location.search);
            const step = urlParams.get('step');
            id = urlParams.get('applicationId');

            if (step == 2) {
                $('#formStep1').addClass('hide');
                $('#formStep2').removeClass('hide');
            }
            if (step == 5) {
                $('#formStep1').addClass('hide');
                checkStatus();
            }
        }

        $(document).on('click', '#btnReUpload', function () {
            $('#formStep5').addClass('hide');
            $('#formStep2').removeClass('hide');
        });

        $('.btn-submit').on('click', e => {
            e.preventDefault();
            let url = this.codeForm.attr('data-app-store');
            let result;

            if($(e.target).attr('data-step') ==  1) {
                result = formHelper.formValidate();
            }

            if($(e.target).attr('data-step') ==  2) {
                result = formHelperStep2.formValidate();
            }

            if(result) {
                e.preventDefault();
                let formData = new FormData();
                let step = $(e.target).attr('data-step');
                const token = this.codeForm.attr('data-token');
                formData.append('step', step);
                formData.append('_token', token);
                $('.btn-submit').addClass('is-loading');

                if (id) {
                    formData.append('id', id);
                }

                $('input[type="text"]').each(function () {
                    const name = $(this).attr('name');
                    if (name) {
                        formData.append(name, $(this).val());
                    }
                });

                let selectedRadio = $('input[type="radio"]:checked');
                if (selectedRadio.length) {
                    let name = selectedRadio.attr('name');
                    if (name) {
                        formData.append(name, selectedRadio.val());
                    }
                }

                $('input[type="checkbox"]').each(function () {
                    let name = $(this).attr('name');
                    if (name) {
                        formData.append(name, $(this).is(':checked') ? 1 : 0);
                    }
                });

                let fileInput = $('input[type="file"]');
                if (fileInput.length && fileInput[0].files.length > 0) {
                    formData.append('file', fileInput[0].files[0]);
                }

                if (step == 2){
                    $('#formStep2').addClass('hide');
                    $('#loadingStep').removeClass('hide');
                }

                setTimeout(() => {
                    $.ajax({
                        url: url,
                        method: 'POST',
                        data: formData,
                        processData: false,
                        contentType: false,
                        success: function (res) {
                            $('.btn-submit').removeClass('is-loading');

                            if (res.success === 1) {
                                if (res.next_step === 2) {
                                    $('#formStep1').addClass('hide');
                                    $('#formStep2').removeClass('hide');
                                    $('#loadingStep').addClass('hide');
                                }
                                if (res.next_step === 3) {
                                    id = res.id;
                                    checkStatus();
                                    $('form').each(function() {
                                        this.reset();
                                        $('#previewContainer').empty();
                                        $('#deleteFileInput').addClass('is-hidden');
                                        $('#previewMultipleContainer').empty();
                                        $('#deleteFileMultipleInput').addClass('is-hidden');
                                    });
                                }
                            }
                            else {
                                $('#formStep1').addClass('hide');
                                $('#formStep4').removeClass('hide');
                                $('#formStep4').html(res.html);
                                $('#loadingStep').addClass('hide');
                            }
                        },
                        error: function (error) {
                            $('.btn-submit').removeClass('is-loading');

                            if (response.status === 419) {
                                console.warn("Sesja wygasła, przeładowanie strony...");
                                window.location.reload(); // Przeładowanie strony
                            }

                            if (error.status === 422 && error.responseJSON.errors) {
                                const errors = error.responseJSON.errors;
                                if (step === 2) {
                                    $('#formStep2').removeClass('hide');
                                    $('#loadingStep').addClass('hide');
                                }
                            }
                        }
                    });
                }, 3000);
            }
        });

        function checkStatus() {
            $.ajax({
                type: 'GET',
                url: '/application/' + id +'/check-status',
                success: function (res) {
                    if (res.success === 1) {
                        $('#loadingStep').addClass('hide');
                        const status = res.data.status;
                        if (status === 'SUCCESS') {
                            $('#formStep4').html(res.data.html);
                            $('#formStep4').removeClass('hide');

                            setTimeout(() => {
                                let codeDate = $('.code-time');

                                if (codeDate) {
                                    let today = new Date();
                                    let futureDate = new Date();
                                    futureDate.setDate(today.getDate() + 28); // Dodajemy 4 tygodnie (28 dni)

                                    let options = { day: 'numeric', month: 'long', year: 'numeric' };
                                    let formattedDate = futureDate.toLocaleDateString('pl-PL', options);

                                    codeDate.text(formattedDate);
                                }
                            }, 0);
                        } else {
                            $('#formStep5').html(res.data.html);
                            $('#formStep5').removeClass('hide');
                        }
                    } else {
                        $('#popupBlockContent').html('<p>Nie udało się zapisać danych.</p>');
                    }
                },
                error: function (error) {
                    console.log(error);
                }
            })
        }
    }
}
